export const stravaConfig = {
  response_type: "code",
  scope: process.env.REACT_APP_STRAVA_SCOPE as string,
  client_id: process.env.REACT_APP_STRAVA_CLIENT_ID as string,
  redirect_uri: process.env.REACT_APP_STRAVA_REDIRECT_URL as string,
}
